import { supportedFileUploadExtensions } from "features/job-management/uploader/constants"
import { useProcessing } from "./useVideoProcessing"
import { useDownloadButtonData } from "./useVideoDownloadButtonData"
import { videoWarningDefinitions } from "./VideoWarnings"
import { deleteVideoFlight, updateVideoFlight } from "features/pubsub/entityActions/flights/video"
import { SampleDataFlightKey, UploadComponentProps } from "@nova/constants"
import { getEmbeddedSrt } from "plugins/ColorFinder/processing/srt"
import { getTelemetryType } from "@nova/telemetry-parsing"
import {
    CreateUploadFlow,
    CreateUploadFlowProps,
    getGenericUploadFlowRenderComponent,
} from "panels/content/side-panel/upload-flow/UploadFlow"
import { VideoPreviewFiles } from "./preview-files/VideoPreviewFiles"
import { GenericAddFiles } from "panels/content/side-panel/upload-flow/GenericAddFiles"
import { selectVideoFlightById } from "features/entity-caching/flights/selectors"
import {
    selectVideoFinishedUploadSize,
    selectVideoUploads,
    selectVideoUploadSize,
} from "features/entity-caching/images/video/selectors"
import { activateSidePanelModal } from "panels/content/side-panel/thunks"
import {
    selectSet,
    deleteUpload,
    uploadFlight,
    stageFiles,
    selectSelectedUpload,
    setSelectedUpload,
    selectVideoJobByFlightId,
    selectUploadsForSetSummary,
    selectUploadIdsForSet,
    selectCancelledUploadIdsForSet,
} from "./VideoSlice"
import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"

const fileFilter = async (files: File[]) => {
    const videoFile = files.find((file) => file.name.toLowerCase().endsWith(".mp4"))
    if (!videoFile) return files
    const srtFile = files.find((file) => file.name.toLowerCase().endsWith(".srt"))
    if (!srtFile) {
        const embeddedSrt = await getEmbeddedSrt(videoFile)
        if (embeddedSrt && getTelemetryType(embeddedSrt) !== undefined)
            files.push(new File([new Blob([embeddedSrt])], "embedded.srt"))
    }
    return files.sort(
        (a, b) =>
            (a.name.toLowerCase().endsWith(".mp4") ? 0 : 1) -
            (b.name.toLowerCase().endsWith(".mp4") ? 0 : 1)
    )
}

const VideoUploadFlow = CreateUploadFlow({
    selectSet,
    selectUploadIdsForSet,
    selectCancelledUploadIdsForSet,
    selectUploadsForSet: selectVideoUploads,
    deleteUpload,
    uploadFlight,
    stageFiles,
    deleteFlight: deleteVideoFlight,
    updateFlight: updateVideoFlight,
    selectJob: selectVideoJobByFlightId,
    useDownloadButtonData,
    useProcessing,
    selectSelectedUpload,
    setSelectedUpload,
    warningDefinitions: videoWarningDefinitions,
    supportedFileUploadExtensions: supportedFileUploadExtensions.video,
    minUploads: 1,
    fileFilter,
    selectFlightById: selectVideoFlightById,
    selectFinishedUploadSize: selectVideoFinishedUploadSize,
    selectUploadsForSetSummary: selectUploadsForSetSummary,
    selectUploadSize: selectVideoUploadSize,
    setSelectedPlugin: activateSidePanelModal,
    maxUploads: 2,
    dropboxTitle: "Upload Video",
    pluginImageUrl: "/images/plugins/layers/video.svg",
    pluginId: NovaPluginIds.Video,
    sampleDataFlightKey: SampleDataFlightKey.fmv1,
} as unknown as CreateUploadFlowProps)

const VideoRenderComponent = getGenericUploadFlowRenderComponent({
    AddFiles: GenericAddFiles,
    PreviewFiles: VideoPreviewFiles,
})

export const VideoMultifileUpload = (props: UploadComponentProps) => {
    return (
        <VideoUploadFlow {...props}>
            <VideoRenderComponent />
        </VideoUploadFlow>
    )
}
